import { createFileRoute } from "@tanstack/react-router"
import { MembersMembershipTiersPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/members/membership-tiers"
)({
  component: () => (
    <AuthorizationGate resource={Resource.MEMBERSHIP_TIER} action={Action.READ}>
      <MembersMembershipTiersPage />
    </AuthorizationGate>
  ),
})
